<script setup>
import { ref, defineProps } from 'vue'
// import { useI18n } from 'vue-i18n'
import { setTrack } from '@/api/login'

const props = defineProps({
  title: {
    type: String,
    default: '沟通无界，服务无限',
  },
  desc: {
    type: String,
    default: '了解更多关于移远公司、产品和技术支持的信息。',
  },
  showRegister: {
    type: Boolean,
    default: false,
  },
  minFooter: {
    type: Boolean,
    default: false,
  },
  link: {
    type: String,
    default:
      'https://www.quectel.com.cn/contact?pro=QWxnb1N0b3JlIEFJ566X5rOV6LaF5biC&tagStr=NGExMDllYjU2NDc3OGZjZg&proType=QUnlvIDmlL7lubPlj7A',
  },
})

// const { t } = useI18n()

const handleRegister = () => {
  location.href = 'https://www.quectel.com.cn/register'
}

const track = async () => {
  await setTrack({
    position: 'consultation',
  })
}

const handleConsult = () => {
  track()
  location.href = props.link
}
</script>

<template>
  <section :class="['communication-module', minFooter && 'min-footer']">
    <div class="container-fluid py-xl-4">
      <h2 class="title">{{ props.title }}</h2>
      <p class="dec">{{ props.desc }}</p>
      <div class="text-center">
        <a-button v-if="showRegister" size="large" @click="handleRegister">
          免费注册
        </a-button>
        <a-button
          class="red"
          type="primary"
          danger
          size="large"
          @click="handleConsult"
          >联系我们</a-button
        >
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
@media (min-width: 1200px) {
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .container-fluid {
    padding-right: 60px;
    padding-left: 60px;
  }
}
.text-center {
  // text-align: center;
  display: flex;
  justify-content: center;
  gap: 24px;
}

.red {
  color: #ed000c;
}
.min-footer {
  min-width: 1270px;
  width: 100%;
}

.communication-module {
  background-color: #210079;
  padding-top: 3rem;
  padding-bottom: 3rem;

  .container-fluid {
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    margin-right: auto;
    margin-left: auto;
  }

  .title {
    font-size: 30px;
    color: rgba(255, 255, 255, 1);
    margin: 1.5rem 0 1.5rem 0;
    text-align: center;
    font-weight: 400;
  }

  .dec {
    font-size: 18px;
    color: rgba(255, 255, 255, 1);
    padding: 0.25rem 0 0.25rem 0;
    text-align: center;
    margin-bottom: 1.5rem;
    font-weight: 400;
  }
}

:deep() {
  .ant-btn-default {
    background-color: #fff;
    border-radius: 4px;
    color: #220079;
  }

  .ant-btn-primary {
    color: rgba(255, 255, 255, 1);
    background-color: #ed000c;
    border-radius: 4px;
  }
}
</style>
